import { useState } from 'react';
import styled from 'styled-components';

import { Loader } from 'components/Loader';
import { CreateConsumptionVariationPopup } from './Popups/CreateConsumptionVariationPopup';
import { ConsumptionVariationDetails } from './ConsumptionVariationDetails';
import { ColumnsSectionContainer, SectionColumn, SectionContainer } from 'components/DetailsView/Section';
import { TotemPrimaryButton } from 'components/TotemPrimaryButton';
import { useGetSiteConsumptionVariationsQuery, TotadminPermission } from 'data/__generated__';

// Section annexe repliée : la requête vit dans le contenu, montée seulement avec `StockVariationsRead` et à la
// première ouverture (`lazy`).
export const ConsumptionVariations = ({ siteId }: { siteId: string }) => (
    <SectionContainer
        title="Variation de la consommation"
        isInitiallyOpen={false}
        lazy
        requiredPermissions={[TotadminPermission.StockVariationsRead]}
    >
        <ConsumptionVariationsContent siteId={siteId} />
    </SectionContainer>
);

const ConsumptionVariationsContent = ({ siteId }: { siteId: string }) => {
    const [isCreateConsumptionVariationPopupOpen, setIsCreateConsumptionVariationPopupOpen] = useState<boolean>(false);

    const {
        loading: consumptionVariationsLoading,
        data: consumptionVariationsData,
        error: consumptionVariationsError,
    } = useGetSiteConsumptionVariationsQuery({ variables: { siteId } });

    if (consumptionVariationsLoading && !consumptionVariationsData) {
        return <Loader />;
    }

    if (consumptionVariationsError || !consumptionVariationsData) {
        return <ErrorMessage>Erreur lors de la récupération des variations de consommation</ErrorMessage>;
    }

    const sortedConsumptionVariations = [...consumptionVariationsData.siteConsumptionVariations]
        .sort((consumptionVariationA, consumptionVariationB) =>
            consumptionVariationB.endDate.localeCompare(consumptionVariationA.endDate),
        )
        .sort((consumptionVariationA, consumptionVariationB) =>
            consumptionVariationB.startDate.localeCompare(consumptionVariationA.startDate),
        );

    return (
        <>
            <ColumnsSectionContainer numberOfColumns={1}>
                <SectionColumn>
                    <TotemPrimaryButton
                        requiredPermissions={[TotadminPermission.StockVariationsManage]}
                        onClick={(e) => {
                            e.preventDefault();
                            setIsCreateConsumptionVariationPopupOpen(true);
                        }}
                    >
                        Ajouter une variation de la consommation
                    </TotemPrimaryButton>
                    {sortedConsumptionVariations.map((consumptionVariation) => (
                        <ConsumptionVariationDetails
                            key={consumptionVariation._id}
                            consumptionVariation={consumptionVariation}
                        />
                    ))}
                </SectionColumn>
            </ColumnsSectionContainer>

            <CreateConsumptionVariationPopup
                siteId={siteId}
                isOpen={isCreateConsumptionVariationPopupOpen}
                setIsOpen={setIsCreateConsumptionVariationPopupOpen}
            />
        </>
    );
};

const ErrorMessage = styled.div`
    color: ${({ theme }) => theme.errorColor};
    padding: 10px;
`;
